import React from 'react'

export default function Modal({ open, title, children, onClose }) {
  React.useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose?.()
    }
    if (open) window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative w-[min(560px,92vw)] rounded-2xl border border-white/10 bg-panel/90 glow">
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <div className="text-base font-semibold">{title}</div>
          <button type="button" onClick={onClose} className="text-white/60 hover:text-white">×</button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  )
}
